export const Roles = {
    ADMIN: 'ADMIN',
    GUEST: 'GUEST',
};